import React from 'react';
import { Helmet } from '../../../modules/foundation/components/HelmetProvider';
var defaultProps = {};
export default function BreadcrumbListSchema(_ref) {
  var items = _ref.items;
  var data = {
    '@context': 'https://schema.org',
    '@type': 'BreadcrumbList',
    itemListElement: items.map(function (_ref2, index) {
      var name = _ref2.name,
        url = _ref2.url;
      return {
        '@type': 'ListItem',
        position: index + 1,
        item: url,
        name: name
      };
    })
  };
  return /*#__PURE__*/React.createElement(Helmet, null, /*#__PURE__*/React.createElement("script", {
    type: "application/ld+json"
  }, JSON.stringify(data)));
}
BreadcrumbListSchema.defaultProps = defaultProps;